import axios, { AxiosError, AxiosResponse } from 'axios';
import { AuthApi } from './auth/auth';

const baseURL = window.location.href.includes('localhost') ? 'http://localhost:3000' : '/';
const axiosInstance = axios.create({
  baseURL,
  timeout: 25000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('accessToken') || ''}`,
  },
  withCredentials: true
});

let isRefreshing = false;

async function refreshKeycloakToken(): Promise<boolean> {
  console.log("Refreshing keycloak token")
  try {
    const params = new URLSearchParams();
    params.append('grant_type', 'refresh_token');
    params.append('client_id', 'portal');

    const response = await AuthApi.refreshAccessToken({ client: 'portal' });
    const { accessToken } = response;

    localStorage.setItem('accessToken', accessToken);
    return true;
  } catch (error) {
    return false;
  }
}
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      if (!isRefreshing) {
        isRefreshing = true;
        const success = await refreshKeycloakToken();
        if (success && error.config) {
          isRefreshing = false;
          return axiosInstance(error.config);
        } else {
          isRefreshing = false;
          window.location.reload();
        }
      }
    }
    return Promise.reject(error);
  }
);

export const api = {
  get: async <T>(url: string, config?: object): Promise<T> => {
    const response = await axiosInstance.get<T>(url, config);
    return response.data;
  },

  post: async <T, B = unknown>(url: string, body: B, config?: object): Promise<T> => {
    const response = await axiosInstance.post<T>(url, body, config);
    return response.data;
  },

  put: async <T, B = unknown>(url: string, body: B, config?: object): Promise<T> => {
    const response = await axiosInstance.put<T>(url, body, config);
    return response.data;
  },

  delete: async <T>(url: string, config?: object): Promise<T> => {
    const response = await axiosInstance.delete<T>(url, config);
    return response.data;
  },
};
